import React from 'react';
import { cn } from '../../lib/utils';

export interface TabItem {
  id: string;
  label: string;
  icon?: string;
}

export interface DashboardTabsProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

export default function DashboardTabs({
  tabs,
  activeTab,
  onTabChange,
  className,
}: DashboardTabsProps) {
  return (
    <div className={cn('border-b border-slate-200', className)}>
      <nav className="flex gap-1 -mb-px" aria-label="Tabs">
        {tabs.map((tab) => {
          const isActive = tab.id === activeTab;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={cn(
                'flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors',
                isActive
                  ? 'border-primary text-primary'
                  : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
              )}
            >
              {tab.icon && (
                <span className="material-symbols-outlined text-[20px]">{tab.icon}</span>
              )}
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
